var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitecirclevector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.5C33 17.1362 30.6684 18.3903 30.1803 19.8664C29.6747 21.3965 30.7926 23.7539 29.8494 25.0275C28.8963 26.3139 26.2617 25.9928 24.9525 26.929C23.6559 27.8559 23.1579 30.4211 21.6002 30.9177C20.0974 31.3971 18.166 29.6251 16.5002 29.6251C14.8344 29.6251 12.903 31.3971 11.4002 30.9177C9.84251 30.4211 9.34457 27.8559 8.04797 26.929C6.7383 25.9928 4.10412 26.3139 3.15103 25.0275C2.20738 23.7539 3.32571 21.3965 2.82012 19.8664C2.33164 18.3899 0 17.1362 0 15.5C0 13.8638 2.33164 12.6097 2.81967 11.1336C3.32526 9.60354 2.20738 7.24611 3.15058 5.97254C4.10367 4.68614 6.73831 5.00719 8.04752 4.07102C9.34457 3.14415 9.84251 0.578873 11.4002 0.0822687C12.903 -0.397089 14.8344 1.37486 16.5002 1.37486C18.166 1.37486 20.097 -0.397089 21.6002 0.0822687C23.1579 0.578873 23.6559 3.14415 24.9525 4.07102C26.2621 5.00719 28.8963 4.68614 29.8494 5.97254C30.7931 7.24611 29.6747 9.60354 30.1803 11.1336C30.6684 12.6097 33 13.8638 33 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitecirclevector);
export default __webpack_public_path__ + "static/media/whitecirclevector.7e0ed42fc061b6f7ca391dc48e3be2b1.svg";
export { ForwardRef as ReactComponent };